/* eslint-disable camelcase */
import { AGORA_API_URL, fmhAPI } from 'api/APIBase';

/** Get all referrals */
export async function getReferralEvents(referralId) {
    const url = `${AGORA_API_URL}/referral_events/${referralId}`;
    return fmhAPI.base.url(url).get().json();
}

/** Get a referral by ID */
export async function getReferralById({ referralId }) {
    const url = `${AGORA_API_URL}/referrals/${referralId}`;
    return fmhAPI.base.url(url).get().json();
}

/**
 * Get filtering options for referrals
 * @param {*} date_filter The date range to check
 * @returns dictionary of distinct values for each column
 */
export async function getReferralFilterOptions({ timeFrameFilter }) {
    const url = `${AGORA_API_URL}/referrals/filter_options`;
    return fmhAPI.base
        .url(url)
        .query({
            date_filter: timeFrameFilter,
        })
        .get()
        .json();
}

export async function remarketReferral({
    referral_id,
    payer_id,
    segment_id,
    supplier_npi,
    route_code,
    offer_rate,
    default_rate,
    reason,
    source,
    username,
}) {
    const url = `${AGORA_API_URL}/remarket`;
    return fmhAPI.base
        .url(url)
        .post({
            referral_id,
            payer_id,
            segment_id,
            supplier_npi,
            route_code,
            default_rate,
            offer_rate,
            reason,
            source,
            username,
        })
        .json();
}

/** Find treatments by patient and product */
export async function findTreatments({
    member_id,
    patient_first_name,
    patient_last_name,
    patient_dob,
    treatment_id,
    friendly_id,
    auth_id,
}) {
    const url = `${AGORA_API_URL}/treatments`;
    return fmhAPI.base
        .url(url)
        .post({
            member_id,
            patient_first_name,
            patient_last_name,
            patient_dob,
            treatment_id,
            friendly_id,
            case_id: auth_id,
        })
        .json();
}
